<template>
    <div class="o-protector">
        <template v-if="protector">
            <m-title
                :title="protector.name"
                :subtitle="typeof protector.is_deleted === 'boolean' && protector.is_deleted === true ? 'archiwalny' : ''"
            >
                <a-button
                    :icon="protector.is_favorite ? 'Favorite' : 'FavoriteLight'"
                    @click="$store.dispatch('protectorFavorite', protector.id)"
                    :is-processing="protectorStatus === 'settingFavorite'"
                />
                <a-button
                    icon="Note"
                    @click="$store.dispatch('modalShow', 'note')"
                />
                <div class="m-title__buttons">
                    <a-button
                        v-if="protector.label_links && protector.label_links.length === 1"
                        class="m-title__button"
                        @click="openLabel(protector.label_links[0])"
                    >
                        Etykieta
                    </a-button>
                    <a-button
                        v-if="protector.label_links && protector.label_links.length > 1"
                        class="m-title__button"
                        @click="showLabels = !showLabels"
                    >
                        Etykiety
                    </a-button>
                    <div
                        v-if="protector.label_links && protector.label_links.length > 1 && showLabels"
                        class="o-protector__labels"
                    >
                        <a
                            class="o-protector__labelsItem"
                            :href="label"
                            v-for="(label, labelIdx) in protector.label_links"
                            v-bind:key="`label${labelIdx}`"
                        >
                            Etykieta {{ labelIdx + 1 }}
                        </a>
                    </div>
                    <a-button
                        v-if="protector.msds_link"
                        class="m-title__button"
                        @click="openLabel(protector.msds_link)"
                    >
                        MSDS
                    </a-button>
                </div>
            </m-title>
            <div
                class="l-row"
                v-if="protector.description || protector.dosage"
            >
                <div class="l-row__column">
                    <template v-if="protector.description && descriptionWithoutTags">
                        <p class="a-label">Informacje o produkcie</p>
                        <p class="a-text" v-html="protector.description"></p>
                    </template>
                    <template v-if="protector.dosage">
                        <p class="a-label">Dawkowanie</p>
                        <p class="a-text">{{ protector.dosage }}</p>
                    </template>
                </div>
            </div>
            <m-note
                v-if="note"
                :content="note"
            ></m-note>
            <m-list-card
                v-if="protector.active_substances && protector.active_substances.length > 0"
                title="Substancje aktywne"
                icon="ActiveSubstances"
                router-single-name="active-substance"
                :list="protector.active_substances"
            />
            <div v-if="isEmployee()" class="l-row">
                <div class="l-row__column">
                    <a-button
                        type="fullwidth"
                        class="a-button"
                        @click="navigation('protector-substitutes', { isSubstitutes: true})"
                    >
                        Zbliżone produkty
                    </a-button>
                    <div class="l-row__column--12 a-text--small a-text--gray">
                        Wyszukiwane są produkty o podobnej zawartości Substancji Aktywnej, mogą występować różnice w formulacji,
                        rodzaju nośników czy nawet typie samej Substancji Aktywnej w wyszukanych ŚOR.
                    </div>
                </div>

            </div>
            <m-list-card
                v-if="protector.agrofags && protector.agrofags.length > 0"
                title="Agrofagi"
                icon="Agrofags"
                router-single-name="agrofag"
                :list="protector.agrofags"
            />
            <m-list-card
                v-if="protector.crops && protector.crops.length > 0"
                title="Uprawy"
                icon="Crops"
                router-single-name="crop"
                :list="protector.crops"
            />
            <div class="l-row">
                <div class="l-row__column">
                    <p class="a-label">Grupa środków</p>
                    <p
                        v-if="protector.protector_types"
                        class="a-text"
                    >
                        <span
                            v-for="(protectorType, protectorTypeIdx) in protector.protector_types"
                            v-bind:key="protectorTypeIdx"
                        >
                            {{ protectorType.name }}<template v-if="protectorTypeIdx < protector.protector_types.length-1">,</template>
                        </span>
                    </p>
                    <template v-if="protector.producer">
                        <p class="a-label">Producent</p>
                        <p class="a-text">{{ protector.producer.name }}</p>
                    </template>
                    <template v-if="protector.ingredients">
                        <p class="a-label">Składniki</p>
                        <p class="a-text">{{ protector.ingredients }}</p>
                    </template>
                </div>
            </div>
            <m-gallery
                v-if="protector.photos && protector.photos.length > 0"
                :images="photos"
            />
            <a-youtube
                v-if="protector.youtube_link"
                :src="protector.youtube_link"
            ></a-youtube>
            <m-tabs
                v-if="protectorsRelated"
                :items="protectorsRelated"
                @input="tab = $event.value"
                :selected="tab"
                :center="true"
            />
            <m-list
                v-if="tab === 'agrii_protectors'"
                router-single-name="agrii-protector"
                :list="protector.agrii_protectors"
            >
                <template slot="list" slot-scope="props">
                    <div class="m-list__itemPhoto">
                        <a-image
                            v-if="props.item.photos && props.item.photos.length > 0 && !!props.item.photos.find(item => item.is_main === true)"
                            :src="props.item.photos.find(item => item.is_main === true).full_uri"
                            :alt="props.item.name"
                        />
                        <figure
                            v-else
                            class="a-image"
                        ></figure>
                    </div>
                    <p
                        class="m-list__itemTitle m-list__itemTitle--margins m-list__itemTitle--capitalize"
                        :style="authIsAdvisor && props.item.position_group ? { color: props.item.position_group.hex } : false"
                    >
                        {{ props.item.name }}
                    </p>
                    <div class="m-list__itemIcons">
                        <a-icon
                            v-if="props.item.youtube_link"
                            class="m-list__icon"
                            icon="Video"
                        />
                        <a-icon
                            class="m-list__icon"
                            :icon="props.item.notes && props.item.notes.length > 0 ? 'Note' : 'NoteLight'"
                        />
                        <a-icon
                            class="m-list__icon"
                            :icon="props.item.is_favorite ? 'Favorite' : 'FavoriteLight'"
                        />
                    </div>
                </template>
            </m-list>
            <m-list
                v-if="tab === 'similar_protectors'"
                router-single-name="protector"
                :list="protector.similar_protectors"
            >
                <template slot="list" slot-scope="props">
                    <div class="m-list__itemPhoto">
                        <a-image
                            v-if="props.item.photos && props.item.photos.length > 0 && !!props.item.photos.find(item => item.is_main === true)"
                            :src="props.item.photos.find(item => item.is_main === true).full_uri"
                            :alt="props.item.name"
                        />
                        <figure
                            v-else
                            class="a-image"
                        ></figure>
                    </div>
                    <p
                        class="m-list__itemTitle m-list__itemTitle--margins m-list__itemTitle--capitalize"
                        :style="authIsAdvisor && props.item.position_group ? { color: props.item.position_group.hex } : false"
                    >
                        {{ props.item.name }}
                    </p>
                    <div class="m-list__itemIcons">
                        <a-icon
                            v-if="props.item.youtube_link"
                            class="m-list__icon"
                            icon="Video"
                        />
                        <a-icon
                            class="m-list__icon"
                            :icon="props.item.notes && props.item.notes.length > 0 ? 'Note' : 'NoteLight'"
                        />
                        <a-icon
                            class="m-list__icon"
                            :icon="props.item.is_favorite ? 'Favorite' : 'FavoriteLight'"
                        />
                    </div>
                </template>
            </m-list>
            <m-list
                v-if="tab === 'complementary_protectors'"
                router-single-name="protector"
                :list="protector.complementary_protectors"
            >
                <template slot="list" slot-scope="props">
                    <div class="m-list__itemPhoto">
                        <a-image
                            v-if="props.item.photos && props.item.photos.length > 0 && !!props.item.photos.find(item => item.is_main === true)"
                            :src="props.item.photos.find(item => item.is_main === true).full_uri"
                            :alt="props.item.name"
                        />
                        <figure
                            v-else
                            class="a-image"
                        ></figure>
                    </div>
                    <p
                        class="m-list__itemTitle m-list__itemTitle--margins m-list__itemTitle--capitalize"
                        :style="authIsAdvisor && props.item.position_group ? { color: props.item.position_group.hex } : false"
                    >
                        {{ props.item.name }}
                    </p>
                    <div class="m-list__itemIcons">
                        <a-icon
                            v-if="props.item.youtube_link"
                            class="m-list__icon"
                            icon="Video"
                        />
                        <a-icon
                            class="m-list__icon"
                            :icon="props.item.notes && props.item.notes.length > 0 ? 'Note' : 'NoteLight'"
                        />
                        <a-icon
                            class="m-list__icon"
                            :icon="props.item.is_favorite ? 'Favorite' : 'FavoriteLight'"
                        />
                    </div>
                </template>
            </m-list>
            <o-modal name="note">
                <p class="a-title a-title--small">
                    Notatka
                </p>
                <br />
                <textarea
                    placeholder="Treść notatki"
                    name="note"
                    class="a-control__textarea"
                    v-model="note"
                ></textarea>
                <template v-slot:actions>
                    <a-button
                        class="a-button--fullwidth a-button--smaller"
                        :process-on-click="true"
                        @click="submitNote"
                    >Zapisz</a-button>
                </template>
            </o-modal>
        </template>
        <a-spinner v-else />
    </div>
</template>

<script>
import MNote from '@/components/MNote'
export default {
    metaInfo() {
        return {
            title: this.metaTitle
        }
    },
    components: {
        MNote
    },
    data() {
        return {
            noteValue: '',
            tab: '',
            metaTitle: 'Środek',
            showLabels: false
        }
    },
    computed: {
        userRoles() {
            return this.$store.getters.authUserRole
        },
        protector() {
            return this.$store.getters.protector
        },
        protectorStatus() {
            return this.$store.getters.protectorStatus
        },
        note: {
            get() {
                return this.$store.getters.protectorNote
            },
            set(note) {
                this.noteValue = note
            }
        },
        protectorsRelated() {
            const related = []
            if(this.protector.agrii_protectors.length > 0) {
                related.push({
                    value: 'agrii_protectors',
                    label: 'Dostępne opakowania'
                })
            } else if(this.protector.similar_protectors.length > 0) {
                related.push({
                    value: 'similar_protectors',
                    label: 'Podobne'
                })
            }
            if(this.protector.complementary_protectors.length > 0) {
                related.push({
                    value: 'complementary_protectors',
                    label: 'Dodatki'
                })
            }
            return related
        },
        descriptionWithoutTags() {
            return this.protector.description.replace(/(<([^>]+)>)/gi, '')
        },
        photos() {
            return this.protector.photos.map(item => item.full_uri)
        },
        authIsAdvisor() {
            return this.$store.getters.authIsAdvisor
        }
    },
    methods: {
        isEmployee() {
            return this.userRoles.some(role => role.symbol === 'admin' || role.symbol === 'employee' || role.symbol === 'advisor')
        },
        fetchProtector() {
            if(!isNaN(this.$route.params.id)) {
                this.$store.dispatch('fetchProtector', this.$route.params.id).then(() => {
                    this.metaTitle = this.protector.name
                    // init tabs
                    if(this.protector.agrii_protectors.length > 0) {
                        this.tab = 'agrii_protectors'
                    } else if(this.protector.similar_protectors.length > 0) {
                        this.tab = 'similar_protectors'
                    } else if(this.protector.complementary_protectors.length > 0) {
                        this.tab = 'complementary_protectors'
                    }
                })
            } else {
                this.$router.push({ name: 'error404' })
            }
        },
        submitNote() {
            this.$store.dispatch('submitNote', {
                id: this.protector.id,
                note: this.noteValue,
                model: 'protectors'
            }).then(() => {
                this.$store.dispatch('modalHide')
                this.$store.dispatch('addNotification', {
                    type: 'success',
                    content: 'Dodano notatkę'
                })
                this.fetchProtector()
            }).catch(() => {
                this.$store.dispatch('addNotification', {
                    type: 'danger',
                    content: 'Wystąpił błąd podczas dodawania notatki.'
                })
            })
        },
        openLabel(url) {
            window.open(url, '_blank')
        },
        navigation(name, params) {
            this.$router.push({ name, params: params })
        }
    },
    created() {
        this.fetchProtector()
    }
}
</script>
